const $ = jQuery.noConflict();

'use strict';
const LoadMoreSpecialProducts = {
	$domLoadBtn: $('.js-load-more-specials'),
	$specialsButtonLoader: $('.js-specials-button-loader'),
	perPage: 12,
	nextPage: 2,
	listToShow: [],

	init: function() {
		if (this.$domLoadBtn.length > 0) {
			this.initPerPage();
			this.preLoadNextPage();
			this.bindEvents();
		}
	},

	initPerPage: function() {
		const perPage = $('.js-load-more-specials').data('per-page');
		if (perPage) {
			this.perPage = perPage;
		}
	},

	preLoadNextPage: function() {
		const _this = this;
		$.ajax({
			method: 'POST',
			url: window.fwsLocalized.ajaxUrl,
			data: {
				action: 'load-more-specials',
				page: _this.nextPage,
				perPage: _this.perPage
			},
			beforeSend: function() {
				_this.ajaxExecuting = true;
			},
			success: function(response) {
				_this.listToShow = response.success ? response.data : [];
			},
			error: function() {
				_this.listToShow = [];
			}
		});
	},

	bindEvents: function() {
		const _this = this;

		this.$domLoadBtn.on('click', function() {
			if (_this.listToShow?.products?.length > 0) {
				_this.renderProducts(_this.listToShow.products);
				_this.nextPage++;
				_this.preLoadNextPage();
			}

			if (_this.listToShow?.products_left >= 0) {
				_this.updateButtonText(_this.listToShow.products_left);
			}

			_this.listToShow = [];
		});
	},

	renderProducts: function(products) {
		products.forEach((product) => {
			const html = `
				<div class="specials-list__item">
					<div class="product-item">
						<div class="product-item__image-wrap">
							<div class="product-item__image media-wrap--lazy-thumb media-wrap media-wrap--259x130 is-hidden">
								<img class="media-item contain-img" src="${product.image ?? ''}" loading="lazy" alt="">
							</div>
						</div>
						<div class="product-item__info">
							<h3 class="product-item__title">${product.title ?? ''}</h3>
							<span class="product-item__size">${product.size ?? ''}</span>
						</div>
						<a class="product-item__btn btn btn--border" href="${product.url ?? ''}">View Details</a>
					</div>
				</div>
			`;
			$('.specials-list__items').append(html);
		});
	},

	updateButtonText: function(productsLeft) {
		if (productsLeft === 0) {
			this.$domLoadBtn.remove();
		} else {
			$('.js-specials-button-counter').text(productsLeft + ' more');
		}
	},
};

export default LoadMoreSpecialProducts;
